import { render, staticRenderFns } from "./ProjectDropDown.vue?vue&type=template&id=8b28a042&scoped=true&"
import script from "./ProjectDropDown.vue?vue&type=script&lang=js&"
export * from "./ProjectDropDown.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDropDown.vue?vue&type=style&index=0&id=8b28a042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b28a042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b28a042')) {
      api.createRecord('8b28a042', component.options)
    } else {
      api.reload('8b28a042', component.options)
    }
    module.hot.accept("./ProjectDropDown.vue?vue&type=template&id=8b28a042&scoped=true&", function () {
      api.rerender('8b28a042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/ClientLayout/components/ProjectDropDown.vue"
export default component.exports